// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = (): void => {
    navigate('/');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}
    >
      <div
        style={{
          textAlign: 'center',
          padding: '2rem'
        }}
      >
        <div
          style={{
            fontSize: '6rem',
            fontWeight: 'bold',
            color: '#5fcfac',
            marginBottom: '1rem'
          }}
        >
          404
        </div>
        <h1
          style={{
            fontSize: '2rem',
            fontWeight: '600',
            color: '#212529',
            marginBottom: '1rem'
          }}
        >
          Page not found
        </h1>
        <p
          style={{
            fontSize: '1.125rem',
            color: '#6c757d',
            marginBottom: '2rem'
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>

        <button
          onClick={handleGoHome}
          style={{
            backgroundColor: '#5fcfac',
            color: 'white',
            border: 'none',
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          Go to home
        </button>

        <div
          style={{
            marginTop: '2rem',
            fontSize: '0.875rem',
            color: '#6c757d'
          }}
        >
          If you believe this is an error, please contact support or try refreshing the page.
        </div>
      </div>
    </div>
  );
};

export default NotFound;
